import api from "./axios-http";

export const portalLogin = async (loginData) => {
  try {
    const response = await api.post("/api/portal/login", loginData);
    return response.data;
  } catch (error) {
    throw error;
  }
};